/* global modForm */

/**
 * Adds a hidden vapi input to the form if one does not already exist.
 * @returns {void}
 */
export function addHiddenVapiInput() {
	const $vapiInput = document.createElement('input');
	const $firstHiddenInput = modForm.opts.form.querySelector(':scope > input[type="hidden"]');

	$vapiInput.type = 'hidden';
	$vapiInput.id = 'vapi';
	$vapiInput.name = 'vapi';
	$vapiInput.value = 'true';

	if (!modForm.opts.form.querySelector('input#vapi')) {
		if ($firstHiddenInput) {
			modForm.opts.form.insertBefore($vapiInput, $firstHiddenInput);
		} else {
			modForm.opts.form.appendChild($vapiInput);
		}
	}
}
